<template>
  <vs-switch class="mt-5" @click="changeContentCategoryStatus()" :value="isSelected"></vs-switch>
</template>

<script>
import _ from 'lodash'

export default {
  data () {
    return {
      isSelected:false
    }
  },

  beforeMount () {
    this.isSelected = this.params.data.status === this.$constants.ADSET_CONTENT_CATEGORY_STATUS.ACTIVE
  },

  methods: {
    async changeContentCategoryStatus () {

      const newStatus = this.isSelected ? this.$constants.ADSET_CONTENT_CATEGORY_STATUS.INACTIVE : this.$constants.ADSET_CONTENT_CATEGORY_STATUS.ACTIVE

      try {
        const response = await window.axios.patch(`/campaigns/adset-content-categories/${this.params.data.id}`, {
          'adset_id': this.params.data.adset_id,
          'status': newStatus,
          'content_category_id': this.params.data.content_category_id,
          'bid_price': this.params.data.bid
        })

        if (response.status === 200) {
          this.isSelected = !this.isSelected

          this.params.node.setData({
            ...this.params.node.data,
            id: response.data.payload.id,
            status: response.data.payload.status
          })

          this.$nextTick(() => {
            this.params.api.refreshCells({
              rowNodes: [this.params.node],
              force: true
            })
          })
        }
      } catch (error) {

        this.$parent.$parent.$parent.$emit('modal-updated', {
          body: this.constructValidationMessage(error),
          type: 'error',
          show: true
        })
      }
    },

    constructValidationMessage (error) {
      const errorKey = _.first(_.keys(_.get(error, 'response.data.errors')))
      return _.get(error, `response.data.errors.${errorKey}`).join(', ')
    }


  }
}
</script>

<style lang='scss' scoped>
  .vs-switch-primary {
    background-color: #d80027 !important;
    top: -15%;
  }

  .vs-switch-active {
    background-color: #009bde !important;
  }
</style>
